import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import {DownloadRS} from '../../../core/service/downloadRS.rest';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import SchadenfallRS from '../../../core/service/schadenfallRS.rest';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import TSSchadenfall from '../../../models/TSSchadenfall';
import DVBernUtil from '../../../utils/DVBernUtil';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IFormController = angular.IFormController;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./bemerkungView.html');

export class BemerkungViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = BemerkungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<'
    };
}

export class BemerkungViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$state', 'DvDialog', '$translate', 'RoleUtilService', 'SchadenfallRS', 'DownloadRS'];
    schadenfall: TSSchadenfall;
    form: IFormController;
    scopeToShow: Array<TSBemerkungScope> = [];
    scope: TSBemerkungScope = TSBemerkungScope.BEMERKUNG_VIEW;

    showBenutzerBemerkungen: boolean = true;
    showTransitionBemerkungen: boolean = true;
    showSystemBemerkungen: boolean = false;

    doctype: TSDocumentType = TSDocumentType.FONDSSUISSE_DOC;


    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private  $q: IQService, $scope: IScope, private $state: IStateService, private dvDialog: DvDialog,
                private $translate: ITranslateService, private roleUtilService: RoleUtilService,
                private schadenfallRS: SchadenfallRS, private downloadRS: DownloadRS) {
        super(schadenfallModelManager, $scope, $state.current.name);
    }

    $onInit() {
        super.$onInit();
        if (!this.schadenfall) {
            console.error('no schadenfall passed to view');
        } else {
            this.initialModel = this.schadenfall;
            this.model = angular.copy(this.schadenfall);
        }
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.schadenfall);
    }

    public downloadPDF(event: any): void {
        this.schadenfallRS.generateDeckblatt(this.schadenfall.id).then(result => {
            console.log(result);
            this.downloadRS.getAccessTokenDocument(this.schadenfall.id, TSDocumentType.TMP_DECKBLATT, result.id).then(result => {
                let win: Window = this.downloadRS.prepareDownloadWindow();
                this.downloadRS.startDownload(result.accessToken, result.filename, false, win);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/bemerkungView/bemerkungView.ts